import type { ServiceConfig } from './services'

// Единый формат сервиса для основного интерфейса
export const mainService: ServiceConfig = {
	// layout: () => import('@/components/layout/MainLayout.vue'),
	spaceTool: {
		title: 'Дашборд',
		icon: 'dashboard',
		description: 'Стартовая страница и сводка пространства',
		entryAction: 'dashboard',
		target: 's',
		order: 10
	},
	actions: {
		'resolve_space': () => import('@/views/spaces/SpaceResolveView.vue'),
		'spaces_list': () => import('@/views/spaces/SpacesListView.vue'),
		'content': () => import('@/views/content/ContentView.vue'),
		'settings': () => import('@/views/settings/SettingsView.vue'),
		'dashboard': () => import('@/views/dashboard/DashboardView.vue')
	}
}
